'use client';

import noImage from '@/assets/webp/no-image.webp';
import { useState } from 'react';

export const useImageObserver = (initialSrc?: string | null, withReplace?: boolean) => {
  const [overrideSrc, setOverrideSrc] = useState<string | null | undefined>(undefined);
  const [isBroken, setIsBroken] = useState(false);

  // Derive imgSrc directly from props — no useEffect lag on src change
  const imgSrc =
    overrideSrc !== undefined
      ? overrideSrc
      : initialSrc
        ? initialSrc
        : withReplace
          ? noImage.src
          : null;

  const handleError = () => {
    setIsBroken(true);
    setOverrideSrc(withReplace ? noImage.src : null);
  };

  const handleLoad = () => {
    setIsBroken(false);
  };

  const setImageSource = (src?: string | null) => {
    setOverrideSrc(src || null);
    setIsBroken(false);
  };

  // Reset override when src changes (new object navigation)
  const [prevSrc, setPrevSrc] = useState(initialSrc);
  if (initialSrc !== prevSrc) {
    setPrevSrc(initialSrc);
    setOverrideSrc(undefined);
    setIsBroken(false);
  }

  return {
    imgSrc,
    isBroken,
    handleError,
    handleLoad,
    setImageSource,
  };
};
